import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ThemeToggle } from '@/components/ThemeToggle';
import { Loading } from '@/components/Loading';
import { ROLE_LABEL_ZH } from '@/lib/labels';

/**
 * Awaiting-approval / revoked screen. Signed in via Cloudflare Access but with
 * no approved role lands here. /api/me auto-creates the pending admin_users row
 * on first call (server-side), so a super_admin can approve in 使用者管理. Once
 * approved, the next /api/me poll reflects the role — no token refresh dance
 * (role is live from D1). The "重新整理" button just re-polls /api/me.
 */
export function Pending() {
  const { loading, email, role, status, refresh } = useAuth();
  const [refreshing, setRefreshing] = useState(false);

  if (loading) return <Loading />;
  if (!email) return <Navigate to="/login" replace />;
  if (status === 'approved' && role) return <Navigate to="/dashboard" replace />;

  const revoked = status === 'revoked';

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await refresh();
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-card">
        <h2>{revoked ? '權限已撤銷' : '等待審核中'}</h2>
        <p style={{ color: 'var(--text-muted)', margin: '0 0 var(--space-2)' }}>
          以 <strong style={{ color: 'var(--text)' }}>{email}</strong> 登入
          {revoked ? ',但此帳號的後台權限已被撤銷。' : ',已送出存取申請。'}
        </p>
        <p
          style={{
            color: 'var(--text-subtle)',
            fontSize: 'var(--text-caption)',
            margin: '0 0 var(--space-5)',
          }}
        >
          {revoked
            ? `若認為有誤,請聯絡${ROLE_LABEL_ZH.super_admin}重新授予角色。`
            : `請通知${ROLE_LABEL_ZH.super_admin}在「使用者管理 → 待審核」核准你的角色。核准後本頁會自動進入,或點下方重新整理。`}
        </p>

        <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
          <button
            type="button"
            className="signin-btn"
            onClick={handleRefresh}
            disabled={refreshing}
          >
            {refreshing ? '重新整理中…' : '重新整理權限'}
          </button>
        </div>

        <div className="login-theme">
          <ThemeToggle />
        </div>
      </div>
    </main>
  );
}
